module.exports = __webpack_public_path__ + "bd71cdf8cf5a0e38d7168457c2c8fec4.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/189.png
// module id = 1772
// module chunks = 2